import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  getAllPageSuccess,
  getAllSuccess,
  createSuccess,
  updateSuccess,
  deleteSuccess,
  getByIdSuccess,
  error,
  getAllPage,
} from './actions';

import { ServiceVinculada } from '~/services/modulos/serviceVinculada';
import { createSagaReutils, createAllTakeLastDefault } from '~/utils/reutils';

import ACTION from '../actionTypes';

const ACOES_DEFULT = createSagaReutils(
  `/vinculada`,
  ServiceVinculada,
  getAllPage,
  getAllSuccess,
  createSuccess,
  updateSuccess,
  deleteSuccess,
  getByIdSuccess,
  error
);

function* listPageableSaga({ params }) {
  try {
    const list = yield call(ServiceVinculada.getAllPageable, params);
    yield put(getAllPageSuccess(list));
  } catch (e) {
    yield put(error(e));
  }
}

export default all([
  ...createAllTakeLastDefault({ modulo: 'VINCULADA', ACOES: ACOES_DEFULT }),
  takeLatest(ACTION.VINCULADA_GET_SEARCH_PAGE, listPageableSaga),
]);
